export default ({...props}) => {
  const {size, space, themeGrey, unit} = props.theme
  return `
        display: table;
        margin: auto;
        
        @media screen and (max-width: 376px){
          width: ${unit(100)}%;
        }

        @media screen and (max-width: 501px) {
          display: flex;
          flex-direction: column;
          flex-grow: 1;

          > div {
            margin: 0;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
          }
        }

        &:not(.demostyled-atom) > div > div.fieldset-wrapper {
          width: ${size(12.5)}%;
          max-height: calc(80vh - ${size(50.75)}px);
          overflow-y: auto;

          @media screen and (max-width: 769px){
            max-height: calc(${size(10)}vh - ${size(31.75)}px);
          }

          @-moz-document url-prefix() {
            scrollbar-width: thin;
            scrollbar-color: #d6dee1 transparent;
            padding-right: ${space(1)}px;
          }

          ::-webkit-scrollbar {
            width: ${size(2)}px;
          }
          
          ::-webkit-scrollbar-track {
            background-color: transparent;
          }
          
          ::-webkit-scrollbar-thumb {
            background-color: #d6dee1;
            border-radius: ${space(2)}px;
            border: ${size(0.5)}px solid transparent;
            background-clip: content-box;
          }

          @media screen and (max-width: 501px) {
              display: flex;
              flex-direction: column;
              flex-grow: 1;
          }

          @media screen and (max-width: 321px) {
            max-height: calc(100vh - ${size(56.75)}px);
          }
          
        }

        & div.eco-description {
          display: flex;
          gap: ${space(1)}px;
          margin-top: ${space(2)}px;
          padding: ${space(0.625)}px 0;
          border-top: 1px solid ${themeGrey.border_grey};
          border-bottom: 1px solid ${themeGrey.border_grey};

          & > div[ap_atom_name="svgIconAtom"] {
            min-width: ${size(3)}px;
            position: relative;
            display: -webkit-box;
            > svg {
              width: ${size(12.5)}%;
            }
          }

          & > p {
            margin: 0;
            text-align: left;
          }
        }

      @media only screen 
      and (min-device-width: 390px) 
      and (max-device-width: 736px) 
      and (-webkit-min-device-pixel-ratio: 2) 
      and (orientation: portrait) {
        &:not(.demostyled-atom) > div > div.fieldset-wrapper {
          width: ${size(12.5)}%;
          max-height: calc(${size(12.5)}vh - ${size(57.5)}px);
          overflow-y: auto;
          margin-bottom: ${0}px;
          
        }
      }
      @media only screen 
      and (min-device-width: 360px) 
      and (max-device-width: 389px) 
      and (-webkit-min-device-pixel-ratio: 2) 
      and (orientation: portrait) {
        &:not(.demostyled-atom) > div > div.fieldset-wrapper {
          width: ${size(12.5)}%;
          max-height: calc(${size(12.5)}vh - ${size(57.5)}px);
          overflow-y: auto;
          margin-bottom: ${0}px;
          
        }
      }
    `
}
